module.exports = __webpack_public_path__ + "img/not-result.7fcc4378.png";